<template>
	<div class="body infodd">
		<div class="page intada" style="position: relative;">
			<template>
				<div class="header">
					<img src="../../assets/image/header.png" />
				</div>
				<div class="content">
					<div class="left">
						<div class="box-qyry">
							<div class="box-title">企业荣誉</div>
							<div class="qyry-wen">
								<div class="flex-sub qyry-wen-text" style="margin-bottom: 0.03rem;"><img class="icon-bd"
											src="../../assets/image/icon-bd.png" />
											近三年国家科技型中小企业总数:<span>{{ detailtt.keji_count }}</span></div>
								<div class="flex-sub qyry-wen-text" style="margin-bottom: 0.03rem;"><img class="icon-bd"
											src="../../assets/image/icon-bd.png" />高新技术企业:<span>{{ detailtt.gaoxin_count
											}}</span>
									</div>
								<div class="margin-bottom qyry-wen-text"><img class="icon-bd"
										src="../../assets/image/icon-bd.png" />“专精特新”企业
									市级/省级:<span>{{ detailtt.zhuanjing_count_city }}/{{ detailtt.zhuanjing_count_province
									}}</span>
								</div>
								<!-- <div class="qyry-wen-text"> <img class="icon-bd"
										src="../../assets/image/icon-bd.png" />拥有“研发平台”企业
									市级/省级/国家级:<span>{{ detailtt.yanfa_city }}/{{ detailtt.yanfa_province }}/{{
											detailtt.yanfa_country
									}}</span>
								</div> -->
							</div>
							<div style="text-align:center;">郑州市近三年增长情况</div>
							<div style="display: flex;align-items: center;justify-content:center;">
								<div class="tttt" style="width: 35%;height: 2.6rem;margin-top: 0;" id="qyryEchart"></div>
								<div class="tttt" style="width: 60%;height: 2.6rem" id="qyryEchart1"></div>
							</div>
						</div>
						<div class="box-zscq">
							<div class="box-title">知识产权</div>
							<div id="zscqEchart"></div>
						</div>
						<div class="box-qyfb">
							<div class="box-title">企业行业分布</div>
							<div id="qyfbEcharts"></div>
						</div>
					</div>
					<div class="center">
						<div class="box-qitu">
							<div class="building-tools" v-if="building1Action + 1 > 0">
								{{ building1Action + 1 }}楼
							</div>
							<div class="box-jcxx-title">企业基础信息</div>
							<div class="building-box">
								<img class="building-bg" src="../../assets/image/building.png" />
								<div class="box-building1" @mouseleave="mouseleavechange">
									<template>
										<!-- 三层往上 -->
										<div class="box-building1-left">
											<template v-for="(item, index) in 21">
												<div class="box-storey" :class="{ action: oneindex == index }"
													:style="{ top: 0.092 * (17 - 1 - index + 3) + 'rem' }"
													v-if="index > 2" @mouseenter="mouseenterchange(index, 1)"
													@click="foolclick(index, 1)">
												</div>
											</template>
										</div>
										<div class="box-building1-right">
											<template v-for="(item, index) in 21">
												<!-- ,width: 0.51-(0.006*(17-1-index)) +'rem' -->
												<div class="box-storey" :class="{ action: oneindex == index }"
													:style="{ top: 0.063 * (17 - 1 - index + 3) + 'rem' }"
													v-if="index > 2" @mouseenter="mouseenterchange(index, 1)"
													@click="foolclick(index, 1)">
												</div>
											</template>
										</div>
									</template>
									<template>
										<!-- 底部三层 -->
										<div class="box-building1-d-left">
											<template v-for="(item, index) in 3">
												<div class="box-storey" :class="{ action: oneindex == index }"
													:style="{ top: 0.075 * (2 - index) + 'rem' }"
													@mouseenter="mouseenterchange(index, 1)"
													@click="foolclick(index, 1)">
												</div>
											</template>
										</div>
										<div class="box-building1-d-right">
											<template v-for="(item, index) in 3">
												<div class="box-storey" :class="{ action: oneindex == index }"
													:style="{ top: 0.054 * (2 - index) + 'rem' }"
													@mouseenter="mouseenterchange(index, 1)"
													@click="foolclick(index, 1)">
												</div>
												<!-- @mouseenter="building1Action=index" -->
											</template>
										</div>
									</template>
								</div>
								<div class="box-building2" @mouseleave="mouseleavechange">
									<div class="box-building2-01">
										<template v-for="(item, index) in 17">
											<div class="box-storey" :class="{ action: twoindex == index }"
												:style="{ top: 0.085 * (17 - 1 - index) + 'rem' }"
												@mouseenter="mouseenterchange(index, 2)" @click="foolclick(index, 2)">
											</div>
										</template>
									</div>
									<div class="box-building2-02">
										<template v-for="(item, index) in 17">
											<div class="box-storey" :class="{ action: twoindex == index }"
												:style="{ top: 0.088 * (17 - 1 - index) + 'rem' }"
												@mouseenter="mouseenterchange(index, 2)" @click="foolclick(index, 2)">
											</div>
										</template>
									</div>
									<div class="box-building2-03">
										<template v-for="(item, index) in 17">
											<div class="box-storey" :class="{ action: twoindex == index }"
												:style="{ top: 0.168 * (17 - 1 - index) + 'rem' }"
												@mouseenter="mouseenterchange(index, 2)" @click="foolclick(index, 2)">
											</div>
										</template>
									</div>
								</div>

								<div class="box-building3" @mouseleave="mouseleavechange">
									<div class="box-building3-01">
										<template v-for="(item, index) in 17">
											<div class="box-storey" :class="{ action: threeindex == index }"
												:style="{ top: 0.105 * (17 - 1 - index) + 'rem' }"
												@mouseenter="mouseenterchange(index, 3)" @click="foolclick(index, 3)">
											</div>
										</template>
									</div>
									<div class="box-building3-02">
										<template v-for="(item, index) in 17">
											<div class="box-storey" :class="{ action: threeindex == index }"
												:style="{ top: 0.09 * (17 - 1 - index) + 'rem' }"
												@mouseenter="mouseenterchange(index, 3)" @click="foolclick(index, 3)">
											</div>
										</template>
									</div>
									<div class="box-building3-03">
										<template v-for="(item, index) in 17">
											<div class="box-storey" :class="{ action: threeindex == index }"
												:style="{ top: 0.09 * (17 - 1 - index) + 'rem' }"
												@mouseenter="mouseenterchange(index, 3)" @click="foolclick(index, 3)">
											</div>
										</template>
									</div>
								</div>

								<div class="box-building4" @mouseleave="mouseleavechange">
									<template>
										<div class="box-building4-01">
											<template v-for="(item, index) in 26">
												<div class="box-storey" :class="{ action: fourindex == index }"
													:style="{ top: 0.08 * (17 - 1 - index) + 'rem' }" v-if="index > 2"
													@mouseenter="mouseenterchange(index, 4)"
													@click="foolclick(index, 4)">
												</div>
											</template>
										</div>
										<div class="box-building4-02">
											<template v-for="(item, index) in 26">
												<!-- ,width:index>14?(0.1-(0.02*(index-14))+'rem'):'0.1rem' -->
												<div class="box-storey" :class="{ action: fourindex == index }"
													v-if="index > 2"
													:style="{ top: 0.09 * (17 - 1 - index) + 'rem', marginLeft: index > 14 ? (0.02 * (index - 14) + 'rem') : 0, width: index > 14 ? (0.61 - (0.02 * (index - 14)) + 'rem') : '0.61rem' }"
													@mouseenter="mouseenterchange(index, 4)"
													@click="foolclick(index, 4)">
												</div>
											</template>
										</div>
										<div class="box-building4-03">
											<template v-for="(item, index) in 26">
												<div class="box-storey" :class="{ action: fourindex == index }"
													v-if="index > 2" :style="{ top: 0.068 * (17 - 1 - index) + 'rem' }"
													@mouseenter="mouseenterchange(index, 4)"
													@click="foolclick(index, 4)">
												</div>
											</template>
										</div>
									</template>

									<template>
										<div class="box-building4-d-01">
											<template v-for="(item, index) in 3">
												<div class="box-storey" :class="{ action: fourindex == index }"
													:style="{ top: 0.1 * (17 - 1 - index) + 'rem' }"
													@mouseenter="mouseenterchange(index, 4)"
													@click="foolclick(index, 4)">
												</div>
											</template>
										</div>
										<div class="box-building4-d-02">
											<template v-for="(item, index) in 3">
												<div class="box-storey" :class="{ action: fourindex == index }"
													:style="{ top: 0.12 * (17 - 1 - index) + 'rem' }"
													@mouseenter="mouseenterchange(index, 4)"
													@click="foolclick(index, 4)">
												</div>
											</template>
										</div>
										<div class="box-building4-d-03">
											<template v-for="(item, index) in 3">
												<div class="box-storey" :class="{ action: fourindex == index }"
													:style="{ top: 0.09 * (17 - 1 - index) + 'rem' }"
													@mouseenter="mouseenterchange(index, 4)"
													@click="foolclick(index, 4)">
												</div>
											</template>
										</div>
									</template>

								</div>


								<div class="box-building7" @mouseleave="mouseleavechange">
									<div class="box-building7-01">
										<template v-for="(item, index) in 6">
											<div class="box-storey" :class="{ action: sevenindex == index }"
												:style="{ top: 0.088 * (6 - 1 - index) + 'rem' }"
												@mouseenter="mouseenterchange(index, 7)" @click="foolclick(index, 7)">
											</div>
										</template>
									</div>
									<div class="box-building7-02">
										<template v-for="(item, index) in 6">
											<div class="box-storey" :class="{ action: sevenindex == index }"
												:style="{ top: 0.1 * (6 - 1 - index) + 'rem' }"
												@mouseenter="mouseenterchange(index, 7)" @click="foolclick(index, 7)">
											</div>
										</template>
									</div>
								</div>

								<div class="box-building10" @mouseleave="mouseleavechange">
									<div class="box-building10-01">
										<template v-for="(item, index) in 3">
											<div class="box-storey" :class="{ action: zhongindex == index }"
												:style="{ top: 0.078 * (3 - 1 - index) + 'rem' }"
												@mouseenter="mouseenterchange(index, 10)" @click="foolclick(index, 10)">
											</div>
										</template>

									</div>
								</div>
							</div>


						</div>
						<div class="box-yqqy">
							 
							<div class="box-title" style="display: flex;align-items: center;justify-content: space-between;">{{ qyxxtype ? '企业信息展示' : '园区企业展示' }}</div>
							<div style="color: #fff;position: absolute;right:0.25rem;font-size: 15px;cursor: pointer;z-index: 99;top: 0.05rem;"  @click="jump('/enterprise')">More</div>
							<div style="height: 0.2rem;"></div>
							<template v-if="!qyxxtype">
								<el-carousel   arrow="never"
									style="height: 3.1rem;width:100%;margin: auto;">
									<el-carousel-item v-for="item in qylist">
										<div class="yqqy-swiper-item">
											<div class="text-center img" style="object-fit: cover;">
												<img class="img" :src="item.newimage | addurl" />
											</div>
											<div class="yqqy-swiper-item-text text-cut2" style="color:#fff;font-size: 0.12rem;font-weight: normal;">
												<span>{{ item.content }}</span>
											</div>
										</div>
									</el-carousel-item>
								</el-carousel>
							</template>
							<template v-else>
								<div style="margin:0.1rem 0.2rem;position: relative;" class="my_table">
									<el-table :data="comlist" style="height:2.9rem;">
										<!-- <el-table-column prop="id" label="序号">
											<template slot-scope="scope">
												<el-tooltip class="item" effect="dark" :content="scope.row.id"
													placement="top-start">
													<div class="yinc text-cut2">{{ scope.row.id }}</div>
												</el-tooltip>
											</template>
										</el-table-column> -->
										<el-table-column prop="hourse_floor" label="楼号/楼层" width="100px">
											<template slot-scope="scope">
												<el-tooltip class="item" effect="dark"
													:content="scope.row.hourse_number+'/'+scope.row.hourse_floor + '楼'" placement="top-start">
													<div class="yinc text-cut2">{{scope.row.hourse_number}}/{{ scope.row.hourse_floor }}楼</div>
												</el-tooltip>
											</template>
										</el-table-column>
										<el-table-column prop="fang_number" label="房间号" width="90px">
											<template slot-scope="scope">
												<el-tooltip class="item" effect="dark" :content="scope.row.fang_number"
													placement="top-start">
													<div class="yinc text-cut2">{{ scope.row.fang_number }}</div>
												</el-tooltip>
											</template>
										</el-table-column>
										<el-table-column prop="company_name" label="企业名称">
											<template slot-scope="scope">
												<el-tooltip class="item" effect="dark" :content="scope.row.company_name"
													placement="top-start">
													<div class="yinc text-cut2">{{ scope.row.company_name }}</div>
												</el-tooltip>
											</template>
										</el-table-column>
										<el-table-column prop="hangye" label="行业" width="150">
											<template slot-scope="scope">
												<el-tooltip class="item" effect="dark" :content="scope.row.hangye"
													placement="top-start">
													<div class="yinc text-cut2">{{ scope.row.hangye }}</div>
												</el-tooltip>
											</template>
										</el-table-column>
										<el-table-column prop="legal" label="联系人" width="100">
											<template slot-scope="scope">
												<el-tooltip class="item" effect="dark" :content="scope.row.legal"
													placement="top-start">
													<div class="yinc text-cut2">{{ scope.row.legal }}</div>
												</el-tooltip>
											</template>
										</el-table-column>
										<el-table-column prop="phone" label="联系方式" width="150">
											<template slot-scope="scope">
												<el-tooltip class="item" effect="dark" :content="scope.row.phone"
													placement="top-start">
													<div class="yinc text-cut2">{{ scope.row.phone }}</div>
												</el-tooltip>
											</template>
										</el-table-column>
									</el-table>
									<div style="width: 100%;text-align: center;position: absolute;bottom: 0rem;">
									<el-pagination @current-change="qyxxchange" :page-size="6" :pager-count="5"
										layout="prev, pager, next" :total="comnum">
									</el-pagination>
								   </div>
								</div>
								 
							</template>
						</div>
					</div>
					<div class="right">
						<div class="box-fwpt">
							<div style="color: #fff;position: absolute;right:0.25rem;font-size: 15px;cursor: pointer;z-index: 99;"  @click="jump('/servicelist')">More</div>
							<div class="box-title">创新服务平台</div>
							<el-carousel  arrow="never" 
								style="height: 3.4rem;" >
								<el-carousel-item v-for="item in detailtt.newservice">
									<div class="fwpt-swiper-item">
										<div style="height:0.4rem;"></div>
										<div class="text-center">
											<img class="img" :src="item.image | addurl" />
										</div>
										<div class="fwpt-swiper-item-text text-cut2" style="color: #fff;font-size: 0.12rem;font-weight: normal;">
											<span>{{ item.content }}</span>
										</div>
									</div>
								</el-carousel-item>
							</el-carousel>
						</div>

						<div class="box-yw">
							<div class="box-title">园区要闻</div>
							<div style="color: #fff;position: absolute;right:0.25rem;font-size: 15px;cursor: pointer;" @click="jump('listpage',2)">More</div>
							<div style="height:0.3rem;"></div>
							<div class="yw-list-box">
								<el-carousel height="2.2rem" arrow="never" >
									<el-carousel-item v-for="item in tableData" :key="item">
										<div class="yw-item" v-for="(eitem, eindex)  in item"
										@click="detailchange('detail', eitem.id, 4)">
										<div class="yw-title cursor-pointer">{{ eitem.title }}
										</div>
										<div class="yw-time cursor-pointer">{{ eitem.realse_time }}</div>
									</div>
									</el-carousel-item>
								</el-carousel>
							</div>
						</div>

						<div class="box-yw" style="position: relative;">
							<div style="color: #fff;position: absolute;right:0.25rem;font-size: 15px;cursor: pointer;"  @click="jump('bulletinlist')">More</div>
							<div class="box-title">政策资讯</div>
							<div style="height:0.3rem;"></div>
							 
							<div class="yw-list-box">
								<el-carousel height="2.2rem" arrow="never" >
									<el-carousel-item v-for="item in tableData1" :key="item">
										<div class="yw-item" v-for="(eitem, eindex)  in item"
										@click="detailchange('detail', eitem.id, 1)">
										<div class="yw-title cursor-pointer">{{ eitem.title }}
										</div>
										<div class="yw-time cursor-pointer">{{ eitem.use_start_time }}</div>
									</div>
									</el-carousel-item>
								</el-carousel>
							</div>
						</div>
						<!-- <div class="box-yq">
							<div class="box-title">园区通知</div>
							<div style="height: 0.3rem;"></div>
							<div class="yq-list-box">
								<div class="yq-list">
									<div class="yq-item" :class="{yqitemji:index%2!=0}" v-for="(item,index) in tzlist" v-if="index<3"  @click="detailchange('detail',item.id,3)">
										{{item.title}}
									</div>
								</div>
							</div>
						</div> -->
					</div>
				</div>
			</template>
		</div>
		<fooldetailpage ref="fooldetailref"></fooldetailpage>
	</div>


</template>

<script>
let color = [
	'#10B9F8', '#FF6A6A', '#90ED7D',
	"#2ec7c9",
	"#b6a2de",
	"#5ab1ef",
	"#ffb980",
	"#d87a80",
	"#8d98b3",
	"#e5cf0d",
	"#97b552",
	"#95706d",
	"#dc69aa",
	"#07a2a4",
	"#9a7fd1",
	"#588dd5",
	"#f5994e",
	"#c05050",
	"#59678c",
	"#c9ab00",
	"#7eb00a",
	"#6f5553",
	"#c14089"
]
import fooldetail from '../common/fooldetail'
var qyry_echart, zscq_echart,qyry_echart1;
var autotime
var autotime1
var autotime2
export default {
	components: {
		fooldetailpage: fooldetail
	},
	data() {
		return {
			qyxxlist: [],
			qyxxtype: false,
			oneindex: 0,
			twoindex: 0,
			threeindex: 0,
			fourindex: 0,
			sevenindex: 0,
			zhongindex: 0,
			autoindex1:0,
			autoindex:0,

			tautoindex1:0,
			tautoindex:0,
			tttindex:0,

			tttindex1:0,
			apiurl: '',
			cdata: 1,
			fontSize: 12,
			timer: false,
			animate: false,
			vlist: [{}],
			building1Action: 0,
			detailtt: '',
			qylist: [],
			currentPage: 1,
			pagesize: 36,
			totalnum: 0,
			tableData: [],
			tzlist: [],
			currentPage1: 1,
			totalnum1: 0,
			tableData1: [],
			currentPage3: 1,
			page_size3: 4,
			comtype: '',
			comindex: '',
			comlist: [],
			comnum: 0,
			buildlist: []
		}
	},
	created() {
		const that = this;
		this.fontSize = this.getRem(1920, 1080, 100);

		window.addEventListener("resize", function () {
			that.fontSize = that.getRem(1920, 1080, 100);
		});
		this.data_show()
		this.goods_company()
		this.notice_list()
		this.notice_list1()
		this.building()
	},
	methods: {
		autotime2(){
			const that = this;
			
            clearInterval(autotime2);
            var Labelist = JSON.parse(JSON.stringify(this.detailtt.new))
            let chartDom = document.getElementById('qyryEchart1');
            let jntgEchart = that.$echarts(chartDom);
			 
            autotime2 = setInterval(function () {
                Labelist.map(($res, $index) => {
                    if ($index < 12) {
                        jntgEchart.dispatchAction({
                            type: "showTip",
                            seriesIndex: 0,
                            dataIndex: $index, //默认选中第二个
                        });
                    }
                })
				 
                jntgEchart.dispatchAction({
                    type: "showTip",
					position:[that.tautoindex1*30, 130],
                    seriesIndex: that.tttindex1,
                    dataIndex: parseInt(that.tautoindex1/3), //默认选中第二个
                });
                jntgEchart.dispatchAction({
                    type: "highlight",
					position:[that.tautoindex1*100, 130],
                    seriesIndex: that.tttindex1,
                    dataIndex:parseInt(that.tautoindex1/3), //默认选中第二个
                });
				
				console.log(parseInt(that.tautoindex1/3),that.tttindex1,'22222222222')
                if (that.tautoindex1 > 7) {
                    that.tautoindex1 = 0;
                } else {
                    that.tautoindex1++;
                }
				if(that.tttindex1>=2){
					that.tttindex1 = 0
				}else{
					that.tttindex1++
				}
            }, 3000);
		},
		autoplay1() {
            const that = this;
			
            clearInterval(autotime1);
            var Labelist = [JSON.parse(JSON.stringify(this.detailtt.new))[0]]
            let chartDom = document.getElementById('qyryEchart');
            let jntgEchart = that.$echarts(chartDom);
			 
            autotime1 = setInterval(function () {
                // Labelist.map(($res, $index) => {
                //     if ($index < 2) {
                //         jntgEchart.dispatchAction({
                //             type: "showTip",
                //             seriesIndex: 0,
                //             dataIndex: $index, //默认选中第二个
                //         });
                //     }
                // })
				 
                jntgEchart.dispatchAction({
                    type: "showTip",
					position:[that.autoindex1*30, 130],
                    seriesIndex: that.tttindex,
                    dataIndex: 0, //默认选中第二个
                });
                jntgEchart.dispatchAction({
                    type: "highlight",
					position:[that.autoindex1*100, 130],
                    seriesIndex: that.tttindex,
                    dataIndex:0, //默认选中第二个
                });
                if (that.autoindex1 >= 2) {
                    that.autoindex1 = 0;
                } else {
                    that.autoindex1++;
                }
				if(that.tttindex>=2){
					that.tttindex = 0
				}else{
					that.tttindex++
				}
            }, 3000);
        },
        autoplay() {
            const that = this;

            clearInterval(autotime);
            var Labelist = JSON.parse(JSON.stringify(this.detailtt.zscq))
            let chartDom = document.getElementById('zscqEchart');
			 
            let zbEchart = that.$echarts(chartDom);
            autotime = setInterval(function () {
                if (that.autoindex == 0) {
                    zbEchart.dispatchAction({
                        type: "showTip",
                        seriesIndex: 0,
                        dataIndex: Labelist.length - 1, //默认选中第二个
                    });
                } else {
                    zbEchart.dispatchAction({
                        type: "downplay",
						position:[that.autoindex*100, 100],
                        seriesIndex: 0,
                        dataIndex: that.autoindex - 1, //默认选中第二个
                    });
                }

                zbEchart.dispatchAction({
                    type: "showTip",
                    seriesIndex: 0,
					position:[that.autoindex*100, 100],
                    dataIndex: that.autoindex, //默认选中第二个
                });

                zbEchart.dispatchAction({
                    type: "select",
					position:[that.autoindex*100, 100],
                    seriesIndex: 0,
                    dataIndex: that.autoindex, //默认选中第二个
                });

                if (that.autoindex == Labelist.length - 1) {
                    that.autoindex = 0;
                } else {
                    that.autoindex++;
                }
            }, 3000);
        },

		jump(path,type){
			this.$router.push({ path:path,query: {type: type}});
		},
		building() {
			var api = this.$api.api.demo.building;
			this.$https.post({
				api: api,
				type: "formData",
			}, {

			}, (response) => {
				this.buildlist = response.data
			}, (error) => {
				console.log(error);
			});
		},
		qyxxchange(e) {
			this.currentPage3 = e
			this.company_list()
		},
		yqchange1(e) {
			this.currentPage1 = e
			this.notice_list1()
		},
		notice_list1() {
			var api = this.$api.api.index.informationList;
			this.$https.post({
				api: api,
				type: "formData",
			}, {
				page: this.currentPage1,
				page_size: this.pagesize,
				type: 4,
				cat_id: 0
			}, (response) => {

				this.totalnum1 = response.count
				var num = 0
				this.tableData1 = []


				response.data.data.map(($ret,$index)=>{
					if($index%6==0&&$index!==0){
						num++
					}
					if(!this.tableData1[num]){
							this.tableData1[num] = []
						}
						this.tableData1[num] = this.tableData1[num].concat($ret)
				})
			}, (error) => {
				console.log(error);
			});
		},
		yqchange(e) {
			this.currentPage = e
			this.notice_list()
		},
		foolclick(index, type) {
			this.comtype = type
			this.comindex = index
			this.company_list()

		},
		company_list() {
			this.loading = true
			this.$https.post(
				{
					api: this.$api.api.demo.company_list,
					type: "formData",
				},
				{
					page: this.currentPage3,
					page_size: 6,
					hourse_number: this.comtype + '#',
					hourse_floor: Number(this.comindex) + 1
				},
				(response) => {
					// this.loading = false
					if (!response.data.length) {
						this.$message({
							message: '暂无数据',
							type: 'warning'
						});
						this.qyxxtype = false
						return
					}
					this.comlist = response.data
					// this.comlist = this.comlist.concat({})
					this.comnum = response.count
					this.qyxxtype = true
				},
				(error) => {
					console.log(error);
				}
			);
		},

		mouseenterchange(index, type) {
			if (type == 1) {
				this.oneindex = index
			} else if (type == 2) {
				this.twoindex = index
			} else if (type == 3) {
				this.threeindex = index
			} else if (type == 4) {
				this.fourindex = index
			} else if (type == 7) {
				this.sevenindex = index
			} else if (type == 10) {
				this.zhongindex = index
			}
			this.building1Action = index
		},
		mouseleavechange() {
			this.oneindex = -1,
				this.twoindex = -1,
				this.threeindex = -1,
				this.fourindex = -1,
				this.sevenindex = -1,
				this.zhongindex = -1,
				this.building1Action = -1
		},
		detailchange(name, id, type) {
			this.$router.push({ name: name, query: { type: type, id: id } });
			 
		},
		notice_list() {
			var api = this.$api.api.demo.notice_list;
			this.$https.post({
				api: api,
				type: "formData",
			}, {
				page: this.currentPage,
				page_size: this.pagesize,
				type: 2,
				cat_id: 0
			}, (response) => {
				this.totalnum = response.count
				var num = 0
				this.tableData = []
				 
				response.data.map(($ret,$index)=>{
					if($index%6==0&&$index!==0){
						num++
					}
					if(!this.tableData[num]){
							this.tableData[num] = []
						}
						this.tableData[num] = this.tableData[num].concat($ret)
				})
			}, (error) => {
				console.log(error);
			});
		},
		goods_company() {
			var api = this.$api.api.demo.goods_company;
			this.$https.post({
				api: api,
				type: "formData",
			}, {
				type: 1
			}, (response) => {
				this.qylist = response.data

			}, (error) => {
				console.log(error);
			});
		},
		data_show() {
			this.$https.post(
				{
					api: this.$api.api.demo.data_show,
					type: "formData",
				},
				{},
				(response) => {
					this.detailtt = response.data
					this.$nextTick(function () {
						this.qiryEchart();
						this.qiryEchart1();
						this.zscqEchart();
						this.hyEcharts();
						this.autoplay()
						this.autoplay1()
						this.autotime2()
						// this.timer = setInterval(this.scroll, 1000)
					})
					console.log(response.data, 'response2222');
				},
				(error) => {
					console.log(error);
				}
			);
		},
		getRem(pwidth, pheight, prem) {
			let fontSize;
			var html = document.getElementsByTagName("html")[0];
			var oHeight = window.innerHeight;
			var oWidth = window.innerWidth;
			let pd = pheight / pwidth;
			let tpd = oHeight / oWidth;
			// console.log(pd, tpd, tpd < pd)
			if (tpd < pd) {
				html.style.fontSize = oHeight / pheight * prem + "px";
				fontSize = oHeight / pheight * prem
			} else {
				html.style.fontSize = oWidth / pwidth * prem + "px";
				fontSize = oWidth / pwidth * prem
			}
			return fontSize
		},
		qiryEchart1() {
			var that = this;
			let chartDom = document.getElementById('qyryEchart1');
			// let qyryEchart = echarts.init(chartDom);
			var detailtt = JSON.parse(JSON.stringify(this.detailtt))
			var nowDate = new Date();
			var yeyyy = nowDate.getFullYear();
			var year2 = yeyyy - 1;
			var year1 = yeyyy - 2;
			var year = yeyyy - 3;
			if (qyry_echart1 != null && qyry_echart1 != "" && qyry_echart1 != undefined) {
				qyry_echart1.dispose();
			}
			qyry_echart1 = this.$echarts(chartDom);
			let option = {
				color: color,
				textStyle: {
					color: "#FFF"
				},
				title: {
					// text: '郑州市近三年增长情况',
					left: 'center',
					textStyle: {
						color: "#ECEFF6",
						fontSize: this.fontSize * 0.19
					}
				},
				legend: {
					// right: this.fontSize * 0.15,
					// top: this.fontSize * 0.35,
					top:8,
					icon: "circle",
					 
					textStyle: {
						color: "#ECEFF6",
						// fontSize: this.fontSize * 0.12
					}
				},
				grid: {
					bottom: this.fontSize * 0.3,
					top:45,
					left:0,
				},
				tooltip: {},
				dataset: {
					dimensions: ['title', year, year1, year2],
					source: [detailtt.new[1],detailtt.new[2],detailtt.new[3]]
				},
				xAxis: {
					type: 'category',
					axisLabel: {
						interval: 0,
						rotate: 0
					}

				},

				yAxis: [
					// {
					// 	max:150,
					// 	splitLine: {
					// 		lineStyle: {
					// 			color: ['#b7b3b3'],
					// 			type: 'dashed'
					// 		}
					// 	},
						
					// },
					{
						type: 'value',
						position: 'right',
						// alignTicks: true,
						max:30,
						min:0,
      					// offset: 80,
						splitLine: {
							show: true,
							lineStyle: {
								color: ['#b7b3b3'],
								type: 'dashed'
							}
						},
					},
					{
						type: 'value',
						position: 'left',
						alignTicks: false,
      					// offset: -92,
						// splitLine: {
						// 	show: false,
						// 	lineStyle: {
						// 		color: ['#b7b3b3'],
						// 		// type: 'dashed'
						// 	}
						// },
						// axisLine: {
							show: false,
							
						// 	lineStyle: {
						// 	color: ['#aaa'],
						// 	type: 'dashed'
						// 	}
						// },
					}
				],
				series: [{
					type: 'bar'
				}, {
					type: 'bar',
					 
				}, {
					type: 'bar',
					yAxisIndex: 1,
				}]
			};


			qyry_echart1.on("mouseover", function (params) {
              
                clearInterval(autotime2);
            });

            qyry_echart1.on("mouseout", function (params) {
                that.autotime2()
            });

			console.log(option);
			option && qyry_echart1.setOption(option);
			window.addEventListener("resize", function () {
				// that.throttle(function () {	},1000) 
				qyry_echart1 && qyry_echart1.resize()
			
			});
		},
		qiryEchart() {
			var that = this;
			let chartDom = document.getElementById('qyryEchart');
			// let qyryEchart = echarts.init(chartDom);
			var detailtt = JSON.parse(JSON.stringify(this.detailtt))

			 
			// detailtt.new = detailtt.new[0]
			console.log(detailtt.new,'detailtt.new')
			var nowDate = new Date();
			var yeyyy = nowDate.getFullYear();
			var year2 = yeyyy - 1;
			var year1 = yeyyy - 2;
			var year = yeyyy - 3;
			if (qyry_echart != null && qyry_echart != "" && qyry_echart != undefined) {
				qyry_echart.dispose();
			}
			qyry_echart = this.$echarts(chartDom);
			let option = {
				color: color,
				textStyle: {
					color: "#FFF"
				},
				title: {
					// text: '郑州市近三年增长情况',
					left: 'center',
					textStyle: {
						color: "#ECEFF6",
						fontSize: this.fontSize * 0.19
					}
				},
				legend: {
					// right: this.fontSize * 0.15,
					type: 'scroll',
					// top: this.fontSize * 0.35,
					top:8,
					icon: "circle",
					textStyle: {
						color: "#ECEFF6",
						fontSize: this.fontSize * 0.12
					}
				},
				grid: {
					bottom: this.fontSize * 0.3,
					left:40,
					top:45,
				},
				tooltip: {},
				dataset: {
					dimensions: ['title', year, year1, year2],
					source: [detailtt.new[0]]
				},
				xAxis: {
					type: 'category',
					axisLabel: {
						interval: 0,
						rotate: 0
					}

				},

				yAxis: [
					{
						max:150,
						splitLine: {
							lineStyle: {
								color: ['#b7b3b3'],
								type: 'dashed'
							}
						},
						
					},
					{
						type: 'value',
						position: 'left',
						alignTicks: true,
      					// offset: -92,
						// splitLine: {
						// 	show: false,
						// 	lineStyle: {
						// 		color: ['#b7b3b3'],
						// 		// type: 'dashed'
						// 	}
						// },
						// axisLine: {
						// 	show: true,
							
						// 	lineStyle: {
						// 	color: ['#aaa'],
						// 	type: 'dashed'
						// 	}
						// },
					}
				],
				series: [{
					type: 'bar',

				}, {
					type: 'bar',
				
					 
				}, {
					type: 'bar',
					
					// yAxisIndex: 1,
				}]
			};


			qyry_echart.on("mouseover", function (params) {
              
                clearInterval(autotime1);
            });

            qyry_echart.on("mouseout", function (params) {
                that.autoplay1()
            });

			console.log(option);
			option && qyry_echart.setOption(option);
			window.addEventListener("resize", function () {
				// that.throttle(function () {	},1000) 
					qyry_echart && qyry_echart.resize()
			
			});
		},
		zscqEchart() {
			var that = this;
			let chartDom = document.getElementById('zscqEchart');
			var detailtt = JSON.parse(JSON.stringify(this.detailtt))
			// let zscqEchart = echarts.init(chartDom);

			if (zscq_echart != null && zscq_echart != "" && zscq_echart != undefined) {
				zscq_echart.dispose();
			}
			zscq_echart = this.$echarts(chartDom);
			let option = {
				color: color,
				textStyle: {
					color: "#FFF"
				},
				grid: {
					bottom: 30,
					left: 50,
					top: 20
				},
				tooltip: {},
				xAxis: {
					type: 'category',
					data: ['作品数量', '软著数量', '专利数量', '商标数量']
				},
				yAxis: {
					splitLine: {
						lineStyle: {
							color: ['#b7b3b3'],
							type: 'dashed'
						}
					}
				},
				series: [{
					data: detailtt.zscq,
					type: 'bar'
				}]
			};
			zscq_echart.on("mouseover", function (params) {
              
			  clearInterval(autotime);
		  });

		  zscq_echart.on("mouseout", function (params) {
			  that.autoplay()
		  });

			option && zscq_echart.setOption(option);
			window.addEventListener("resize", function () {
				// that.throttle(function () {	}, 1000)
					zscq_echart && zscq_echart.resize()
			
			});
		},
		hyEcharts() {
			const that = this;
			let chartDom = document.getElementById('qyfbEcharts');
			var detailtt = JSON.parse(JSON.stringify(this.detailtt))
			// let qyfbEcharts = echarts.init(chartDom);
			let qyfbEcharts = this.$echarts(chartDom);
			var datalist = []
			detailtt.hanye.map($e => {
				datalist.push({
					value: $e.num,
					name: $e.industry
				})
			})
			let option = {
				tooltip: {
					trigger: 'item'
				},
				color: color,
				legend: {
					type: 'scroll',
					orient: 'vertical',
					right: 0,
					top: 20,
					bottom: 20,
					textStyle: {
						color: "#FFF",
						fontSize: 10,
					},
					pageIconColor: '#FFF',
					pageIconInactiveColor: "rgba(221, 221, 221, 1)",
					pageTextStyle: {
						color: '#FFF'
					},

				},
				series: [{
					name: '',
					type: 'pie',
					radius: [this.fontSize * 0.3, this.fontSize * 0.8],
					center: ['32%', '50%'],
					roseType: 'area',
					label: {
						formatter: '{d}%\n',
						textBorderColor: "rgba(13, 198, 235, 1)",
						textBorderWidth: 0,
						color: '#FFF',
						minMargin: 5,
						edgeDistance: 20,
						lineHeight: 15,
						rich: {
							time: {
								fontSize: 10,
								color: '#999'
							}
						}
					},
					// labelLayout: function (params) {
					// 	const isLeft = params.labelRect.x < qyfbEcharts.getWidth() / 2;
					// 	const points = params.labelLinePoints;
					// 	// Update the end point.
					// 	points[2][0] = isLeft
					// 		? params.labelRect.x
					// 		: params.labelRect.x + params.labelRect.width;
					// 	return {
					// 		labelLinePoints: points
					// 	};
					// },
					data: datalist
				}]
			}
			option && qyfbEcharts.setOption(option);
			window.addEventListener("resize", function () {
				// that.throttle(function () {},1000) 
					qyfbEcharts && qyfbEcharts.resize()
					// that.hyEcharts()
				
			});
		},

		scroll() {
			let that = this;
			that.$refs.con1.style.marginTop = '-0.32rem';
			that.animate = !that.animate;
			var tableData = JSON.parse(JSON.stringify(that.tableData))
			setTimeout(function () {

				// if(tableData.length<that.totalnum){
				// 	that.currentPage = this.currentPage+1
				// 	var api = this.$api.api.demo.notice_list;
				// 	that.$https.post({
				// 			api: api,
				// 			type: "formData",
				// 		}, {
				// 			page: that.currentPage,
				// 			page_size:1,
				// 			type: 2,
				// 			cat_id:0
				// 		}, (response) => {
				// 			tableData.push(response.data);
				// 			tableData.shift();
				// 		}, (error) => {
				// 			console.log(error);
				// 		});
				// }


				that.$refs.con1.style.marginTop = '0px';
				that.animate = !that.animate; // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
			}, 2500)
		},
		mEnter() {
			clearInterval(this.timer)
		},
		mLeave() {

			// this.timer = setInterval(this.scroll, 3000)
		}, throttle(fn, delay) {
			var flag = true;
			return function () {
				if (flag) {
					setTimeout(() => {
						fn.call(this)
						flag = true;
					}, delay);
				}
				flag = false;
			}
		}
	},
}
</script>
<style scoped>
@import url(./building.css);
@import url(./style.css);
</style>
<style lang="scss">
.intada {
	.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell{
		background-color: rgba(0, 0, 0, 0);
		color: #6EC8DF;
	}
	.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
		border-bottom: 1px solid #6EC8DF !important;
		border-right: 1px solid #6EC8DF !important;
	
	}
	.el-table--enable-row-transition .el-table__body td.el-table__cell:last-child{
		border-right: 0 !important;
	}
	.intada .tablecss .el-table__body, .intada .el-table__footer, .intada .el-table__header{
		border-bottom: 1px solid #6EC8DF !important;
	}
	.tablecss thead .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
		background-color: rgba(0, 0, 0, 0);
		color: #6EC8DF;
	}
	.el-table tr{
		background-color: rgba(0, 0, 0, 0);
	}
	.el-table, .el-table__expanded-cell{
		background-color: rgba(0, 0, 0, 0);
		border: 1px solid #6EC8DF !important;
	}
	.tablecss .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
		border-right: 1px solid #6EC8DF !important;
	}
	 
	.tablecss .el-table__body, .el-table__footer, .el-table__header{
		border-left: 0;
	}
	.el-table--border::after, .el-table--group::after, .el-table::before{
		background-color: rgba(0, 0, 0, 0);
	}
	.el-table--scrollable-x .el-table__body-wrapper{
		color: #fff !important;
	}
	.el-table td.el-table__cell div{
		color: #fff !important;
	}
	.el-table__empty-block {
		width: auto !important;
	}
	.tablecss thead .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf:last-child{
		border-right: 0 !important;
	}
	.yinc {
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}

	table {
		width: auto !important;

	}

	.el-table {
		font-size: 0.15rem;
		height: 2.5rem;
	}

	.el-table th.el-table__cell>.cell {
		padding-left: 0.1rem;
		padding-right: 0.1rem;
	}

	.el-table .cell {
		line-height: 0.342rem;
		text-align: center;
		cursor: pointer;
	}

	.el-table .el-table__cell {
		padding: 0;
	}

	.el-carousel__container {
		height: 100%;
	}

	.el-pagination {
		background-color: rgba(0, 0, 0, 0);
		padding: 0;
	}

	.el-pager li {
		background-color: rgba(0, 0, 0, 0);
		color: #fff;
		font-size: 0.12rem;
		font-weight: 550;
		height: 0.3rem;
		line-height: 0.3rem;
	}

	.el-pagination .btn-prev {
		background-color: rgba(0, 0, 0, 0);
	}

	.el-pagination .btn-next {
		background-color: rgba(0, 0, 0, 0);
	}

	.el-icon-arrow-right {
		color: #fff;
		font-size: 0.12rem;
	}

	.el-icon-arrow-left {
		color: #fff;
		font-size: 0.12rem;
	}

	.el-pager li.btn-quicknext,
	.el-pager li.btn-quickprev {
		color: #fff;
	}

	.el-pagination button,
	.el-pagination span:not([class*=suffix]) {
		height: 0.3rem;
		line-height: 0.3rem;
	}
	// .tttt{
	// 	position: relative;
	// }
	// .tttt::after{
	// 	content:'';
	// 	position: absolute;
	// 	// width: '';
	// 	height:2.05rem;
	// 	bottom:0.3rem;
	// 	border-right: 0.01rem dashed #aaa;
	// 	left: 30%;
		
	// }
}
</style>



// WEBPACK FOOTER //
// information.vue?60ed94b5